<template>
  <div class="flex items-center gap-2">
    <AppIcon
      :name="icon"
      size="24"
    />
    <span
      :class="[
        'value',
        isAchieved ? 'text-green' : 'text-red'
      ]"
    >
      {{ isAchieved ? settings.whitelist_allocation_bonus_in_percent : '0' }}%
    </span>
  </div>
</template>

<script setup>
defineProps({
  icon: {
    type: String,
    required: true
  },
  isAchieved: {
    type: Boolean,
    default: false
  }
})

const settings = useState(appStateConstants.SETTINGS)
</script>

<style lang="scss" scoped>
  .value {
    font-size: 14px;
    line-height: 18px;
  }
</style>